module.exports = __webpack_public_path__ + "static/gallery2-f5c20ca4def8872a195502680e69ab19.jpg";